export const messages = {
  title: 'Memos',
  newMemo: 'New',
  cancel: 'Cancel',
  add: 'Add',
  save: 'Save',
  edit: 'Edit',
  delete: 'Delete',
  clear: 'Clear',
  loading: 'Loading…',
  titlePlaceholder: 'Title (optional)',
  contentPlaceholder: 'Content',
  dueLabel: 'Due',
  dueFormatHint: 'Due date format: 20260716',
  overdue: 'overdue',
  dragHint: 'Drag to reorder',
  noMemos: 'No memos yet',
  noMemosDescription: 'Click "New" to create your first memo',
  newMemoAction: '+ New Memo',
  addSuccess: 'Added',
  addFailed: 'Add failed',
  updateSuccess: 'Updated',
  updateFailed: 'Update failed',
  moveToTrashHint: 'Will be moved to trash',
  movedToTrash: 'Moved to trash',
  trash: 'Trash',
  trashEmpty: 'Trash is empty',
  untitled: 'Untitled',
  deletedAt: 'Deleted {time}',
  restore: 'Restore',
  restoreSuccess: 'Restored',
  restoreFailed: 'Restore failed',
  purge: 'Delete Forever',
  purgeConfirmTitle: 'Delete Forever',
  purgeConfirmMessage: '"{title}" will be permanently deleted. This cannot be undone. Are you sure?',
  purgeSuccess: 'Permanently deleted',
  purgeFailed: 'Delete failed',
  emptyTrash: 'Empty Trash',
  emptyTrashConfirmTitle: 'Empty Trash',
  emptyTrashConfirmMessage: '{count} memo(s) in the trash will be permanently deleted. This cannot be undone. Are you sure?',
  emptyTrashSuccess: 'Trash emptied',
  emptyTrashFailed: 'Failed to empty trash',
  loadFailed: 'Failed to load'
} as const
